/*
 * @Author: your name
 * @Date: 2019-06-19 11:32:26
 * @LastEditTime: 2022-03-24 15:30:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/utils/token.js
 */
import Cookie from "js-cookie";

const TOKEN_NAME = "ZHULOGIC_TOKEN";
// const TOKEN_STAGE_NAME = 'ZHULOGIC_STAGE_TOKEN'
const TOKEN_STAGE_NAME = process.env.VUE_APP_COOKIE_TOKEN;
const TOKEN_NAME_DARK = "ZHULOGIC_TOKEN_DARK";
const DOMAIN = process.env.VUE_APP_COOKIE_DOMAIN;
const SATGE_DOMAIN = process.env.VUE_APP_COOKIE_STAGE_DOMAIN;
const UNIND_NAME = "ZHULOGIC_UNIND";

export function Token() {
  const token = Cookie.get(TOKEN_NAME);
  return token;
}
export function SetToken(value) {
  if (!value) return false;
  const token = Cookie.set(TOKEN_NAME, value, { expires: 30, domain: DOMAIN });
  return token;
}

export function SetStageToken(value) {
  if (!value) return false;
  const token = Cookie.set(TOKEN_STAGE_NAME, value, {
    expires: 30,
    domain: SATGE_DOMAIN,
  });
  return token;
}

export function SetTokenDark(value) {
  if (!value) return false;
  const token = Cookie.set(TOKEN_NAME_DARK, value, {
    expires: 30,
    domain: DOMAIN,
  });
  return token;
}

export function GetTokenDark() {
  const token = Cookie.get(TOKEN_NAME_DARK);
  return token;
}

export function ClearToken() {
  Cookie.remove(TOKEN_NAME, { domain: DOMAIN });
  Cookie.remove(TOKEN_STAGE_NAME, { domain: SATGE_DOMAIN });
}

export function Unind() {
  const unind = Cookie.get(UNIND_NAME);
  return unind;
}
export function SetUnind(value) {
  if (!value) return false;
  const unind = Cookie.set(UNIND_NAME, value, { expires: 30, domain: DOMAIN });
  return unind;
}

export function ClearUnind() {
  Cookie.remove(UNIND_NAME, { domain: DOMAIN });
}
